import PropTypes from 'prop-types';
import React from 'react';
import H4 from 'sushiweb/Typography/Heading/H4';
import H2 from 'sushiweb/Typography/Heading/H2';
import { OrderExpenseRequestCenterAlign } from '../styles';

const ActionResponse = ({ title, comment, actionReason }) => {
  return (
    <>
      <OrderExpenseRequestCenterAlign>
        <H2>{title}</H2>
        <H4>{comment}</H4>
        {actionReason && (
        <H4>
          Reason:
          {actionReason}
        </H4>
)}
      </OrderExpenseRequestCenterAlign>
    </>
  );
};

ActionResponse.defaultProps = {
  title: '',
  comment: '',
  actionReason: '',
};

ActionResponse.propTypes = {
  title: PropTypes.string,
  comment: PropTypes.string,
  actionReason: PropTypes.string,
};

export default ActionResponse;
